<template>
    <section class="graphic-repair-main">
        <base-page-header :breadcrumb="breadcrumb" :title="$t('module-budget.repair-graphic.title')">
        </base-page-header>

        <v-row>
            <v-col class="graphic-wrapper pl-16 bg-white" cols="12" md="8" lg="8">
                <v-row>
                    <v-col cols="12" sm="10">
                        <div>
                            <div class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                                <v-col cols="12" sm="6" md="5" lg="3">
                                    <base-button-back class="mb-5" @click="backClicked">{{$t('back')}}</base-button-back>
                                </v-col>
                                <v-col cols="12" sm="6" md="7" lg="9" class="current-item">
                                    <span style="font-weight: bold !important">{{ decodeHtml(currentItemClicked) }}</span>
                                </v-col>
                            </div>

                            <!-- Removido a pedido, dia 07/01/2021 - TASK 1080 - Azure Devops
                                Para acrescentar de novo, basta inseir os @item no <component
                                @item-hovered="imageItemHovered"
                                @item-hovered-out="imageItemHoveredOut"
                            -->
                            <component
                                :is="xmlImageComponent"
                                :imgXml="carImage"
                                ref="xmlImage"
                                @clicked-on-element="itemClicked"
                                :state="stateCheckImage"
                                @tooltip-name="handleTooltipName"
                                :graphicPreSelectedData="dataGraphicPreSelected"
                            />
                        </div>
                    </v-col>
                </v-row>
                <span class="ml-6" style="position: absolute;margin-top: -35px;">{{$t('module-budget.repair-graphic.message-info1')}} <u class="here-btn-link" @click="onClickHereBtn">{{$t('module-budget.repair-graphic.message-info2')}}</u></span>
            </v-col>

            <v-col class="list-items-wrapper overflow-y-auto mx-auto" cols="12" md="4" lg="4">
                <v-text-field
                    v-model="searchListValue"
                    clearable
                    :label="$t('module-budget.repair-graphic.filter-label')"
                    append-outer-icon="fi fi-2x icon-pesquisar"
                    @click:clear="filterListItems"
                    @click:prepend-inner="filterListItems"
                    @input="filterListItems"
                >
                </v-text-field>

                <div class="list-class">
                    <h3>{{$t('module-budget.repair-graphic.list-class-h3')}}</h3>
                    <!--
                        Removido a pedido, dia 07/01/2021 - TASK 1080 - Azure Devops
                        Para acrescentar de novo, basta inseir os @item no <area-items
                        @item-mouseover="$refs.xmlImage.highlightItem($event)"
                        @item-mouseout="$refs.xmlImage.unlightItem($event)"
                    -->
                    <area-items
                        class="overflow-auto"
                        :items="listItems"
                        :hover-item="hoverItem"
                        @item-clicked="itemClicked"
                    ></area-items>
                </div>
            </v-col>
        </v-row>

        <v-btn rounded class="btn-primary-custom" @click="modalBudgetButtonClicked">
            {{ $t('module-budget.repair-service.budget') }}
        </v-btn>

        <base-modal v-model="modal.open" :title="$t('module-budget.repair-graphic.modal-open.title')" modal-width="680px" @watch-show-value="clickOutsideFuncModal">
            <template v-slot:modal-body >
                <div v-for="item in modal.contents" :key="item.id + '' + item.itemParts.korId + '' + item.itemParts.workId">
                    <div v-if="computedLastBudget" class="items-texts" @click="clickboxCheckManagement('maintenance', item)">
                        <base-checkbox :config="mixinCheckboxValue('maintenance', item)"></base-checkbox>
                    </div>
                    <div v-else class="items-texts" @click="clickboxCheckManagement('repair', item)">
                        <base-checkbox :config="mixinCheckboxValue('repair', item, false)"></base-checkbox>
                    </div>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="primary-button" text @click="modal.open = false">
                        {{$t('module-budget.repair-graphic.modal-open.next')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="modalBudgetButtonClicked()">
                        {{ $t('module-budget.repair-graphic.modal-open.budget') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalError.open" :title="$t('module-budget.repair-graphic.modal-error.title')" modal-width="580px">
            <template v-slot:modal-body >
                <div>
                   {{$t('module-budget.repair-graphic.modal-error.message')}}
                </div>
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="primary-button" text @click="$router.push({name: 'budget'})">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </section>
</template>

<script>

import {
    QuotationGraphicServicesGetCarImage,
    QuotationGraphicServicesGetMainGroupImage,
    QuotationGraphicServicesGetPreSelectedData,
    QuotationGraphicServicesGetRepairGraphicList,
    QuotationGraphicServicesGetSubGroupImage,
    QuotationGraphicServicesGetWorkStep,
} from '@services/b2b/quotation/QuotationGraphicServices.js';
// import XMLImage from '@components/b2b/tech-info/clickable-img/XMLImage';
import XmlCarImage from '@components/b2b/budget-repair-graphic/XmlCarImage';
import XmlSubGroupImage from '@components/b2b/budget-repair-graphic/XmlSubGroupImage';
import {Base64} from 'js-base64';
import {mapGetters} from 'vuex';
import {QuotationServicesGetOptionsClutchKit} from '@services/b2b/quotation/QuotationServices.js';
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BaseButtonBack from "@components/shared/widgets/BaseButtonBack.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

export default {
    components: {
        BasePageHeader,
        BaseButtonBack,
        BaseModal,
        'area-items': () => import('@components/b2b/budget-repair-graphic/ListAreaItems'),
        'base-checkbox': () => import('@components/b2b/widgets/CheckBoxComponent.vue'),
        XmlCarImage,
        XmlSubGroupImage
    },
    data() {
        return {
            breadcrumb: [
                {
                    title: this.$t('module-budget.repair-graphic.breadcrumb1'),
                    routerLinkName: 'budget'
                },
                {
                    title: this.$t('module-budget.repair-graphic.breadcrumb2'),
                }
            ],
            carImage: '',
            allCarItems: [],
            selectedItemsQueue: [],
            listItems: [],
            hoverItem: null,
            unfilteredListItems: [], // used because of the list filter
            currentItemNameProperty: 'mainGroupName',
            searchListValue: '',
            modal: {
                open: false,
                operation: {
                    workId: -1,
                    workPosDescription: '',
                    workPosCriteriaDescription: '',
                    singleWorkTime: -1
                },
                contents: []
            },
            modalError: {
                open: false,
                operation: {
                    workId: -1,
                    workPosDescription: '',
                    workPosCriteriaDescription: '',
                    singleWorkTime: -1
                },
                contents: []
            },
            checkedGraphic: [],
            stateCheckImage: false,

            currentItemClicked: null,
            step1ItemClicked: null,
            step2ItemClicked: null,
            currentTooltipItem: null,
            optionsKit: [],
            dataGraphicPreSelected: []
        };
    },
    computed: {
        ...mapGetters({
            computedCarName: 'vehicleIdentification/controlDetails',
            computedShoppingCart: 'budget/getB2bCurrentShoppingCart'
        }),
        currentStep() {
            return this.selectedItemsQueue.length;
        },
        xmlImageComponent() {
            return this.currentStep === 2 ? 'xml-sub-group-image' : 'xml-car-image';
        },
        firstSelection() {
            return this.allCarItems[this.selectedItemsQueue[0].index];
        },
        secondSelection() {
            return this.firstSelection.subGroups[this.selectedItemsQueue[1].index];
        },
        computedLastBudget() {
          const getLastBudget = this.$store.getters['budget/getLastBudgetSelectedEditToCompare'];
          if(getLastBudget && getLastBudget.quotationId !== null && getLastBudget.quotationId !== undefined) {
            return getLastBudget.quotationId;
          } else {
            return false;
          }
        },
        checkShoppingCart() {
            return this.computedShoppingCart.operations.repair.length === 0;
        },
        currentVehicle() {
            return this.$store.getters["vehicleIdentification/getState"].processNumber;
        },
    },
    methods: {
        /**
         * @description Method that will update the list of items. This will be
         * an async request that immediately provides the information to the first 3 steps
         * of the process.
         * This could a and should be improved to be a request per step, to avoid the backend processing
         * of loads of non-used information
         */
        getItemsList() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            QuotationGraphicServicesGetRepairGraphicList()
                .then(response => {
                    this.allCarItems = response.data.result;
                    this.setListItems();
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalError.open = true;
                    console.error('ERRO', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                });
        },
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        getCarImage() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            let { CarImageService, payload } = getBudgetServiceCarImage.call(this);

            CarImageService({ ...payload })
                .then(response => {
                    this.carImage = Base64.decode(response.data.result);
                    if (this.currentStep === 2) {
                      this.stateCheckImage = true;
                      this.getTheGraphicPreSelectedData();
                    } else {
                      this.stateCheckImage = false
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    console.error('Error in QuotationGraphicServicesGetCarImage response. ', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                });

            function getBudgetServiceCarImage() {
                let BudgetServiceCarImage = null;
                let payload = {};
                // different steps have different API calls for the car image
                switch (this.currentStep) {
                    case 0:
                        BudgetServiceCarImage = QuotationGraphicServicesGetCarImage;
                        break;
                    case 1:
                        BudgetServiceCarImage = QuotationGraphicServicesGetMainGroupImage;
                        payload = { mainGroupId: this.firstSelection.mainGroupId };
                        break;
                    case 2:
                        BudgetServiceCarImage = QuotationGraphicServicesGetSubGroupImage;
                        payload = {
                            mainGroupId: this.firstSelection.mainGroupId,
                            subGroupId: this.secondSelection.subGroupId
                        };
                        break;
                }

                return { CarImageService: BudgetServiceCarImage, payload };
            }
        },
        getOperation(mapId) {
            this.$store.commit('loadings/setStateLoadingTemplate', true);

            QuotationGraphicServicesGetWorkStep(mapId)
                .then(response => {

                    if (!response.data.result || !response.data.result[0].itemParts)
                        throw new Error('Missing result or result[0].itemParts');

                    this.modal.contents = [];

                    let checkBoxClicked = false;

                    response.data.result.map(item => {
                        item.itemParts.map(el => {
                            checkBoxClicked = existsInShoppingCart.call(this, el.workId, el.itemMpId);
                            this.modal.contents.push({
                                id: el.itemMpId,
                                checked: existsInShoppingCart.call(this, el.workId, el.itemMpId),
                                value: `${el.workTime}h ${" "} ${el.itemMpText} ${" "} (${el.korText}) ${" "} [${el.qualColText}]` ,
                                subtitle: el.korText,
                                itemParts: el,
                                mapId: mapId,
                                qualColId: el.qualColId ? el.qualColId : ''
                            });
                        })
                    });
                    this.modal.open = true;

                    if(checkBoxClicked) {
                      const isClutchKitContent = this.modal.contents.find(item => item.id == 127);
                      if(isClutchKitContent) {
                        this.getClutchKit(this.modal.contents);
                      }
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('QuotationGraphicServicesGetWorkStep response. ' + error.message);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                });

            /**
             * @description checks if the item exists in the current shopping cart operations.repair
             */
            function existsInShoppingCart(workId, itemMpId) {
                if(this.computedLastBudget) {
                  const repairOperations = this.computedShoppingCart.operations.repair.concat(this.computedShoppingCart.operations.maintenance);
                  const existsInCart = repairOperations.find(item => String(workId) === String(item.workId) || String(itemMpId) === String(item.itemMpId));
                  return !!existsInCart;
                } else {
                  const repairOperations = this.computedShoppingCart.operations.repair;
                  const existsInCart = repairOperations.find(item => String(workId) === String(item.workId) || String(itemMpId) === String(item.itemMpId));
                  return !!existsInCart;
                }
            }
        },
        setListItems() {
            switch (this.currentStep) {
                case 0:
                    this.listItems = this.allCarItems.map(item => {
                        return {
                            id: item.mainGroupId,
                            name: item.mainGroupName
                        };
                    });
                    break;
                case 1:
                    this.listItems = this.firstSelection.subGroups.map(item => {
                        return {
                            id: item.subGroupId + '-' + item.subGroupQualColId,
                            name: item.subGroupName,
                            description: item.subGroupQualifier
                        };
                    });
                    break;
                case 2:

                    this.listItems = this.secondSelection.itemMps.map(item => {
                        return {
                            id: item.itemMpId,
                            name: item.itemMpText
                        };
                    });
                    break;
                default:
                    break;
            }


            // we use the copy list to be able to filter the items with the search button and being able to easily fall back to initial state of the list (reset)
            this.unfilteredListItems = this.listItems;
        },
        filterListItems() {
            if (!this.searchListValue) this.searchListValue = '';

            this.listItems = this.unfilteredListItems.filter(item => {
                return item.name.toLowerCase().includes(this.searchListValue.toLowerCase());
            });
        },
        /**
         * @param itemId id of the item that was clicked either on the image or the list
         * @param itemIndex index of the listItems that holds the itemId that was clicked
         */
        itemClicked(itemId, index, itemName) {
            this.searchListValue = '';
            const itemIndex = this.unfilteredListItems.findIndex(item => item.id.toString().startsWith(itemId));

            // 2 because the 3rd step is when the piece is going to be selected, so you call the endpoint and present the right information to the user
            if (this.currentStep === 2) {
                this.getOperation(itemId);
                return;
            }

            this.selectedItemsQueue.push({
                index: itemIndex,
                id: itemId,
                carImage: this.carImage
            });
            this.setListItems();
            this.getCarImage();

            let cloneTooltipItemClicked = _.cloneDeep(this.currentTooltipItem);
            if(this.currentStep === 0) {
                this.currentItemClicked = null;
            }
            if(this.currentStep === 1) {
                if(!itemName) {
                    this.step1ItemClicked = cloneTooltipItemClicked;
                    this.currentItemClicked = cloneTooltipItemClicked;
                } else {
                    this.step1ItemClicked = itemName;
                    this.currentItemClicked = itemName;
                }
            }
            if(this.currentStep === 2) {
                if(!itemName) {
                    this.step2ItemClicked = cloneTooltipItemClicked;
                    this.currentItemClicked = cloneTooltipItemClicked;
                } else {
                    this.step2ItemClicked = itemName;
                    this.currentItemClicked = itemName;
                }
            }
            if(this.currentTooltipItem && this.currentStep !== 0 && !this.currentItemClicked) {
                if(this.step1ItemClicked) {
                    this.step1ItemClicked = itemName;
                }
                if(this.step2ItemClicked) {
                    this.step2ItemClicked = itemName;
                }
                this.currentItemClicked = cloneTooltipItemClicked;
            }
        },
        imageItemHovered(itemId) {
            if (itemId) this.hoverItem = itemId;
        },
        imageItemHoveredOut(itemId) {
            if (itemId) this.hoverItem = null;
        },
        backClicked() {
            if(this.currentStep === 0) {
                this.$router.go(-1);
                return;
            }

            this.searchListValue = '';

            // we want the value from the previous step, so that's why currentStep - 1
            this.carImage = this.selectedItemsQueue[this.currentStep - 1].carImage;

            // then we pop the previous step choice because it will be chosen again, and on that point yes, it will be added
            this.selectedItemsQueue.pop();
            this.setListItems();
            this.stateCheckImage = false;

            if(this.currentStep === 0) {
                this.currentItemClicked = null;
            }

            if(this.currentStep === 1) {
                this.currentItemClicked = _.cloneDeep(this.step1ItemClicked);
            }
            if(this.currentStep === 2) {
                this.currentItemClicked = _.cloneDeep(this.step2ItemClicked);
            }
        },
        mixinCheckboxValue(type, item) {
            let value = ' ';
            let checked = false;

            let shoppingCart = this.$store.getters['budget/getB2bCurrentShoppingCart'];

            for (let i in shoppingCart.operations[type]) {
                if (shoppingCart.operations[type][i].workId == item.itemParts.workId) {
                    checked = true;
                }
            }

            return {
                id: item.itemParts.itemMpId,
                checked: checked,
                value: `${item.itemParts.workTime}h ${" "} ${item.itemParts.itemMpText} ${" "} (${item.itemParts.korText}) ${" "} [${item.itemParts.qualColText}]` ,
                subtitle: item.itemParts.korText,
                itemParts: item.itemParts,
                mapId: item.mapId
            };
        },
        async clickboxCheckManagement(type, item) {
            const theMapId = String(item.mapId);
            const theWorkId = String(item.itemParts.workId);
            const theItemMpId = String(item.itemParts.itemMpId);

            const payloadItem = {
              workId: item.itemParts.workId,
              workPosDescription: item.itemParts.itemMpText,
              workPosCriteriaDescription: item.itemParts.korText,
              singleWorkTime: item.itemParts.workTime,
              itemMpId: item.itemParts.itemMpId,
              workTime: item.itemParts.workTime,
              itemMpText: item.itemParts.itemMpText,
              korText: item.itemParts.korText,
              korTexmapIdt: item.itemParts.korText,
              mapId: item.mapId,
              qualColId: item.qualColId ? item.qualColId : ''
            };
            let payload = {
              item: payloadItem,
              type: type
            };
            this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);

            await this.$nextTick();

            if(item.id == 127) {
              const getShoppingCartOperations = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations;
              const concatMaintenanceWithRepairLists = getShoppingCartOperations.maintenance.concat(getShoppingCartOperations.repair);
              const existKitOnList = concatMaintenanceWithRepairLists.find(item => item.itemMpId == 127);
              if(existKitOnList) {
                this.getClutchKit();
              }
            }

            const getShoppingCartOperations = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations;
            const concatMaintenanceWithRepairLists = getShoppingCartOperations.maintenance.concat(getShoppingCartOperations.repair);
            const existTheIdOnList = concatMaintenanceWithRepairLists.find(item => String(item.workId) == theWorkId && String(item.itemMpId) == theItemMpId);
            if(!existTheIdOnList) {
                this.dataGraphicPreSelected = this.dataGraphicPreSelected.filter(element => {
                  const number = element.match(/\d+/);
                  return !(number && number[0] == theMapId);
              });
            }


        },
        operationCheckboxClicked(itemId, korId) {
            this.modal.contents.map(item => {
                if(item.id == itemId && item.itemParts.korId == korId){
                    Object.assign(item, {
                        checked: !item.checked
                    });

                    this.modal.operation = item.itemParts;
                    this.modal.operation = {
                        ...this.modal.operation,
                        mapId: item.mapId
                    };
                }
            });


            addOperationToCart(this);

            function addOperationToCart(context) {
                // shopping cart needs the following attributes to be in the payload in order to display properly in the shopping cart component
                const payloadItem = {
                    workId: context.modal.operation.workId,
                    workPosDescription: context.modal.operation.itemMpText,
                    workPosCriteriaDescription: context.modal.operation.korText,
                    singleWorkTime: context.modal.operation.workTime,
                    itemMpId: context.modal.operation.itemMpId,
                    workTime: context.modal.operation.workTime,
                    itemMpText: context.modal.operation.itemMpText,
                    korText: context.modal.operation.korText,
                    korTexmapIdt: context.modal.operation.korText,
                    mapId: context.modal.operation.mapId
                };

                let payload = {
                    item: payloadItem,
                    type: this.computedLastBudget ? 'maintenance' : 'repair'
                };

                context.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);
            }
        },
        modalBudgetButtonClicked() {
            this.modal.open = false;
            this.storageBudgetStartedBy();
            if(this.computedLastBudget) {
                this.$router.push({
                    name: "budget-summary-edit",
                    params: {
                        id: this.computedLastBudget,
                        edit: true,
                        preventLoadEdit: true,
                    },
                });
            } else {
              this.$router.push({ name: 'budget-summary'});
            }
        },
        storageBudgetStartedBy() {
            const getBudgetStartedBy = this.$store.getters['budget/getBudgetStartedBy'];
            if(!getBudgetStartedBy || !getBudgetStartedBy.budgetId) {
                const payload = {
                    budgetId: 3,
                    budgetName: 'repair-graphic'
                }
                this.$store.commit('budget/setBudgetStartedBy', payload);
            }
        },
        onClickHereBtn() {
            this.$router.push({name: 'budget_repair-service'});
        },
        handleTooltipName(param) {
            this.currentTooltipItem = param;
        },
        clickOutsideFuncModal(value) {
            this.modal.open = value;
        },
        getClutchKit(content) {
          this.$store.commit('loadings/setStateLoadingTemplate', true);
          QuotationServicesGetOptionsClutchKit()
            .then(response => {
              if(response.data.result && response.data.result.length > 0) {
                let res = response.data.result;
                res.forEach((element, index) => {
                  Object.assign(element, { selected: null});
                })
                this.optionsKit = res;

                if(content) {
                  const getShoppingCartCopyParts = this.$store.getters['budget/getShoppingCartCopy'].parts;
                  const arrayParts = Object.values(getShoppingCartCopyParts);
                  const partIdsArray = arrayParts.map(part => String(part[0].partId));

                  this.optionsKit.some((obj) => {
                    const selectedItem = obj.parts.find(item => partIdsArray.includes(item.value));
                    if (selectedItem) {
                      obj.selected = selectedItem.value;
                    }
                  });
                }

                const payload = {
                  show: true,
                  data: null,
                  options: this.optionsKit,
                  removePartIDs: []
                }
                this.$store.commit('budget/setStateOfClutchKit', payload)
              }
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.$store.commit('loadings/setStateLoadingTemplate', false);
            })
        },
        async getTheGraphicPreSelectedData() {
          const getShoppingCartCopyParts = this.$store.getters['budget/getShoppingCartCopy'].parts;
          const getShoppingCartCopyOperations = this.$store.getters['budget/getShoppingCartCopy'].operations;

          const arrayParts = Object.values(getShoppingCartCopyParts);
          const referecesArray = arrayParts.map(part => String(part[0].reference));
          const filteredReferencesArray = referecesArray.filter(item => Boolean(item) && item !== "0" && item !== "undefined" && item !== "null" && item !== "");

          const workIdsArray = arrayParts.map(part => String(part[0].workId));
          const workIdsOperationsArray = getShoppingCartCopyOperations.map(op => String(op.workId));
          const concatWorkIds = workIdsArray.concat(workIdsOperationsArray);
          const filteredWorkIds = concatWorkIds.filter(item => Boolean(item) && item !== "0" && item !== "undefined" && item !== "null" && item !== "");

          const body = {
            selectedPartNo: filteredReferencesArray,
            selectedWorkIds: filteredWorkIds
          }

          this.$store.commit('loadings/setStateLoadingTemplate', true);
          await QuotationGraphicServicesGetPreSelectedData(body)
            .then(response => {
              if(response && response.data.result) {
                this.dataGraphicPreSelected = response.data.result;
              }
            })
            .catch(error => {
              console.error('QuotationGraphicServicesGetPreSelectedData', error);
            })
            .finally(() => {
              this.$store.commit('loadings/setStateLoadingTemplate', false);
            })
        }
    },
    watch: {
        currentVehicle: {
            handler: function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (this.currentStep !== 0) {
                        this.selectedItemsQueue = [];
                        this.currentStep = 0;
                        this.currentItemClicked = null;
                        this.step1ItemClicked = null;
                        this.step2ItemClicked = null;
                    }
                    this.getItemsList();
                    this.getCarImage();
                }
            },
            immediate: true
        },
    },
    mounted() {
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.graphic-wrapper {
    max-height: 100vh;
    overflow: visible;
}

.list-items-wrapper {
    /* max-height: 50vh;
    overflow-x: hidden;
    overflow-y: auto; */

    .list-class {
        max-height: 50vh;
        overflow-x: hidden;
        overflow-y: auto;
    }

    @media (min-width: 1270px) {
        margin-left: 40px;
    }
}

.graphic-repair-main {
    .subtitle {
        color: $grey;
    }
}

::v-deep .div_imgXml{
    table{
        tr{
            td{
                display: none !important;
                &:nth-child(1){
                    display: block !important;
                }
            }
        }
    }
}

.current-item {
    @media(min-width: 1025px) {
        display: flex;
        justify-content: center;
    }
}

.here-btn-link {
    color: var(--v-primary-base);
    cursor: pointer;
}

.btn-primary-custom {
        position: fixed;
        bottom: 50px;
        left: 50%;
        margin-left: -50px;
        z-index: 9;
        text-transform: capitalize;

        @media(max-width: 770px) {
            margin-left: -100px;
            bottom: 70px;
        }

        @media(max-width: 430px) {
            margin-left: -100px;
            bottom: 116px;
        }
    }
</style>
